import { resolveUserProfileTypeWithFallback } from '@/utils/userProfileImage';

export function resolveVipStudioLabel({ ownerType = null, channelKind = null } = {}) {
  const normalizedOwnerType = String(ownerType ?? '').trim().toLowerCase();
  const normalizedChannelKind = String(channelKind ?? '').trim().toLowerCase();

  return normalizedOwnerType === 'artist' || normalizedChannelKind === 'artist_studio'
    ? 'Studio'
    : 'VIP';
}

export function resolveChannelAvatarProfileType({ ownerType = null, channelKind = null } = {}) {
  return resolveUserProfileTypeWithFallback('gallery', channelKind, ownerType);
}

export function formatPaymentDate(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return 'Date not available';
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}

export function formatRangeDateLabel(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return formatPaymentDate(date);
}
